export default "__VITE_ASSET__Oe5njpvA__"